import { Component, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from '@app-core/services/data/data.service';
import { ReportsService } from '@app-reports/services/reports/reports.service';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-delete-report-modal',
  templateUrl: './delete-report-modal.component.html',
  styleUrls: ['./delete-report-modal.component.scss'],
})
export class DeleteReportModalComponent implements OnDestroy {
  public isLoading = false;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<DeleteReportModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      fleetId: string;
      customReportId: string;
      reportName: string;
      clientId?: string;
    },
    private reportService: ReportsService,
    public dataService: DataService
  ) {}

  public onCancel(): void {
    this.dialogRef.close(false);
  }

  public onDelete(): void {
    this.isLoading = true;

    this.reportService
      .deleteCustomReport(this.data.fleetId, this.data.customReportId)
      .pipe(
        takeUntil(this.ngUnsubscribe),
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: () => {
          if (this.data.clientId) {
            this.reportService.deleteReportConversation(this.data.customReportId, this.data.clientId, this.data.fleetId).subscribe();
          }
          this.dialogRef.close(true);
        },
        error: (err) => {
          console.error('Delete API error:', err);
          this.dialogRef.close(false);
        },
      });
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
